const links = {
    socialMedia: {
        twitter: "https://twitter.com/dirtgame",
        facebook: "https://www.facebook.com/dirtgame",
        youtube: "https://www.youtube.com/dirtgame",
        instagram: "https://www.instagram.com/dirtgame",
        discord: "https://discord.gg/BYGnqQB",
    },
    legal: {
        termsAndConditions: "https://www.ea.com/terms-of-service.",
        privacyPolicy: "https://www.ea.com/en-gb/legal/privacy-policy",
        cookiePolicy: "https://www.ea.com/en-gb/legal/privacy-policy",
        contactUs: "https://www.codemasters.com/contact-us/",
    },
    licensing: {
        playstation: "http://playstation.com/",
        xbox: "https://www.xbox.com/",
        steam: "https://store.steampowered.com/",
        stadia: "https://stadia.google.com/",
        pegi: "https://pegi.info/",
        amd: "https://www.amd.com/",
        nvidia: "http://www.nvidia.com/",
        vw: "https://www.vw.com/",
    },
    codemasters: "https://www.codemasters.com/",
    rikAstley: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
};

export default links;
